import React from "react";
import "./HowItWorks.css";

const steps = [
  {
    number: "01",
    title: "Bring & Weigh",
    description:
      "Walk into our T. Nagar store with your gold. We weigh it in front of you on certified scales.",
  },
  {
    number: "02",
    title: "Precision Testing",
    description:
      "Our advanced karat-meter reads exact purity non-destructively. You see the results live.",
  },
  {
    number: "03",
    title: "Transparent Quote",
    description:
      "We calculate value against the day's live gold rate and share a clear, no-pressure offer.",
  },
  {
    number: "04",
    title: "Instant Cash",
    description:
      "Accept and receive cash immediately. Safe, swift and fully documented.",
  },
];

export default function HowItWorks() {
  return (
    <section className="how" id="process">
      <div className="how__header">
        <span className="how__eyebrow">
          <span className="how__eyebrow-line" />
          How It Works
        </span>

        <h2 className="how__headline">
          Four calm steps to <span className="how__highlight">cash in hand</span>.
        </h2>
      </div>

      <div className="how__steps">
        {steps.map((step, i) => (
          <div className="how__step" key={step.number}>
            <div className="how__circle-row">
              <span className="how__circle">{step.number}</span>
              {i < steps.length - 1 && <span className="how__line" />}
            </div>
            <h3 className="how__step-title">{step.title}</h3>
            <p className="how__step-desc">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
